import { render, staticRenderFns } from "./MiniGameListPage.vue?vue&type=template&id=0ebf9a2e"
import script from "./MiniGameListPage.vue?vue&type=script&lang=js"
export * from "./MiniGameListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports